<script>
import formInput from "@/mixins/shared/formInput";

export default {
	mixins: [formInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	}
}
</script>

<template>
	<div class="input-group">
		<span class="input-group-text" v-if="$slots.addonbefore">
			<slot name="addonbefore"/>
		</span>
		<span class="input-group-text" v-if="!$slots.addonbefore">
			<i class="bi bi-globe2"></i>
		</span>
		<input
			:name="name"
			v-bind="$attrs"
			@input="changeModelValue"
			type="text"
			:id="renderedId"
			:class="{'form-control': true, 'border-danger': hasError}"
			:value="modelValue"
			:aria-describedby="`${renderedId}-addon`"
		>
		<span class="input-group-text" v-if="$slots.addonafter">
			<slot name="addonafter"/>
		</span>
	</div>
	<div v-if="$slots.descriptionbottom" class="input-description mt-2">
		<slot name="descriptionbottom" />
	</div>
	<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>